import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import UnarchiveIcon from "@material-ui/icons/Unarchive";
import React from "react";
import { FoldersApi } from "../../../api/folders/folders";
import ToolbarItem from "../../../components/Table/TableToolbar/ToolbarItem";
import { useSnackbar } from "../../../data/SnackbarContext";
import * as Constants from "../../../data/StringConstants";
import analytics from "../../../utils/analytics";

const useStyles = makeStyles({
	toolbarItemContainer: {
		// this unusual number was picked so that the final height calculation of the custom toolbar,
		// including padding, will equal 66px (to match the non-custom toolbar).
		minHeight: "60.167px",
		width: "inherit"
	}
});

/**
 * Renders a custom toolbar that is rendered when a user select a table item
 * @param {obj} selectedRows Rows which the user has selected
 * @param {obj} displayData  Data for each row in the table.
 * @param {obj} resp Current state of the table
 * @param {func} setData Callback to update the state
 */
export default function ArchivedFoldersTableToolbar(props) {
	const { selectedRows, displayData, resp, setData } = props;
	const { showSuccessSnackbar, showErrorSnackbar } = useSnackbar();
	const classes = useStyles();

	const logEvent = {
		type: analytics.eventTypes.FOLDERS.UNARCHIVE_FOLDER_CLICKED,
		properties: {
			numberOfFolders: selectedRows.data.length
		}
	};

	const unarchiveFolders = async () => {
		setData({ isLoading: true });

		const indexes = selectedRows.data.map(row => row.index);
		const indexOfFolderId = 7;
		const selectedFolderIds = indexes.map(
			idx => displayData[idx].data[indexOfFolderId]
		);
		try {
			const result = await FoldersApi.bulkUnarchive(selectedFolderIds);
			const updatedFolders = resp.data.filter(
				item =>
					!result.data.successfullyUnarchivedFolderIds.includes(
						item.Id
					)
			);
			setData({
				data: updatedFolders,
				totalItemCount: result.count,
				isLoading: false
			});
			showSuccessSnackbar(Constants.SNACKBAR_MESSAGES.UNARCHIVE_FOLDER_SUCCESS);
			analytics.logEvent(logEvent.type, logEvent.properties);
		} catch (err) {
			showErrorSnackbar(Constants.SNACKBAR_MESSAGES.UNARCHIVE_FOLDER_ERROR);
		}
	};

	return (
		<Grid container className={classes.toolbarItemContainer} alignItems="center">
			<ToolbarItem
				Icon={<UnarchiveIcon />}
				title="Unarchive"
				handleClick={() => {
					unarchiveFolders();
				}}
			/>
		</Grid>
	);
}
